import { Link } from "react-router-dom";

const Logo = ({ footer = false }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-center" aria-label="Seed Park India — Home">
    <img
      src={footer ? "/assets/seed-park-logo-notag.png" : "/assets/seed-park-logo.png"}
      alt="Seed Park India Pvt. Ltd."
      className={footer ? "h-20 w-auto" : "h-14 w-auto"}
    />
  </Link>
);

export default Logo;
